import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { CallCenterDevicesQuery, CallCenterDevicesQueryVariables } from '@/shared/api';
import CALL_CENTER_DEVICES_QUERY from '../queries/callCenterDevices';

/**
 * Loads the paged call-center device list backing the devices screens. Runs the callCenterDevices query with the filter and limit and throws the first GraphQL error only when no devices came back.
 *
 * @param filter - Filter selecting the devices.
 * @param limit - Maximum number of devices to load; defaults to 10.
 * @returns A promise resolving to the call-center devices payload.
 */
const fetchCallCenterDevices = async (
  filter: CallCenterDevicesQueryVariables['filter'],
  limit = 10,
): Promise<CallCenterDevicesQuery['callCenterDevices']> => {
  const client = createClient();
  const callCenterDevicesResult = await client.query<
    CallCenterDevicesQuery,
    CallCenterDevicesQueryVariables
  >({
    query: CALL_CENTER_DEVICES_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = callCenterDevicesResult;
  const { callCenterDevices } = data;
  if (_.isNil(callCenterDevices) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return callCenterDevices;
};

export default fetchCallCenterDevices;
